import { BASE_BACKEND_URL } from '../../../auth'
import { authJson } from '../../services/shared/authJson'

export async function fetchPermissionCatalog() {
  return authJson(`${BASE_BACKEND_URL}/rbac/permission_catalog`, {
    cache: 'no-store'
  })
}
